import { formatAmount, formatInt } from '@parts/shared';
import type { CellComponent } from 'tabulator-tables';
import { tx } from '../../i18n';
import { avatarColor, initials, STATUS_TONE } from '../ui';

/** Экранирование текста для HTML внутри ячейки. */
export function esc(text: unknown): string {
  return String(text ?? '').replace(/[&<>"]/g, (ch) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' })[ch]!);
}

/** Короткие названия статусов — для узкого столбца (ключи перевода). */
const STATUS_SHORT: Record<string, string> = {
  'Частично выполнен': 'Частично',
  'Частично закуплено': 'Частично',
  'Ожидает закупки': 'Ожидает'
};

/**
 * Статус как цветная метка. Под ширину столбца (CSS-запросы к размеру ячейки):
 * широкий — полное название, узкий — короткое, совсем узкий — только цветная точка; полное название — во всплывающей подсказке.
 */
export function badge(cell: CellComponent): string {
  const value = String(cell.getValue() ?? '');
  if (!value) return '';
  const full = tx(value);
  const short = STATUS_SHORT[value] ? tx(STATUS_SHORT[value]) : full;
  return `<span class="t-pill t-status" data-tone="${STATUS_TONE[value] ?? 'gray'}" title="${esc(full)}"><span class="t-full">${esc(full)}</span><span class="t-short">${esc(short)}</span></span>`;
}

/** Автор: кружок с инициалами и имя. */
export function person(cell: CellComponent): string {
  const value = tx(String(cell.getValue() ?? '').trim());
  if (!value) return '';
  return `<span class="t-person"><span class="t-avatar" style="background:${avatarColor(value)}">${esc(initials(value))}</span>${esc(value)}</span>`;
}

/** Целое число с разделителями разрядов. */
export function numberCell(cell: CellComponent): string {
  const v = cell.getValue();
  return v === '' || v === null || v === undefined ? '' : formatInt(Number(v));
}

/** Сумма: отрицательная подсвечивается красным. */
export function moneyCell(cell: CellComponent): string {
  const raw = (cell.getRow().getData() as { marginValue?: number | null }).marginValue;
  cell.getElement().classList.toggle('cell-bad', typeof raw === 'number' && raw < 0);
  const v = cell.getValue();
  return v === '' || v === null || v === undefined ? '' : String(v);
}

/** Число из ячейки таблицы ввода (для подсказок и проверок). */
export function cellText(value: unknown): string {
  return value === null || value === undefined ? '' : String(value);
}

export { formatAmount };
